import { useMemo } from "react";
import type { UserLocationDetails } from "../../Dashboard/dashboard.component";
import { useRemoteFetchCompanyLocations } from "../../../hooks/Remote/Location/useRemoteFetchCompanyLocations";
import {
  getDashboard2MobileWorkingLocation,
  getDashboard2MobileWorkingLocationFromInventories
} from "../utils/dashboard2-favorite-locations.utils";
import { useDashboard2MobileWorkingEnabled } from "./useDashboard2MobileWorkingEnabled";

/**
 * Resolves the mobile-working location inventory for status-sheet bookings.
 * Prefers last-month usage report; falls back to company location catalog when absent.
 */
export function useDashboard2MobileWorkingLocation(userReport: UserLocationDetails[] | undefined) {
  const mobileWorkingEnabled = useDashboard2MobileWorkingEnabled();
  const fromReport = useMemo(() => getDashboard2MobileWorkingLocation(userReport), [userReport]);
  const needsCompanyLocations = mobileWorkingEnabled && !fromReport;

  const { data: companyLocations } = useRemoteFetchCompanyLocations({
    noMobileWorking: false,
    isFinanceRequest: false,
    isBookingSettings: false,
    enabled: needsCompanyLocations
  });

  return useMemo(() => {
    if (fromReport) {
      return fromReport;
    }
    if (!mobileWorkingEnabled) {
      return undefined;
    }
    return getDashboard2MobileWorkingLocationFromInventories(companyLocations);
  }, [companyLocations, fromReport, mobileWorkingEnabled]);
}
